import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiClient";
import { useAuth } from "@/state/auth";

export interface RateLimitStats {
  perMinute: number;
  perHour: number;
  perDay: number;
  updatedAt?: string | null;
  updatedBy?: string | null;
  source?: string;
}

export interface AdminSummary {
  documents: number;
  tokensUsed: number;
  sessions: number;
  lastActivity: string | null;
  rateLimits: RateLimitStats;
}

export const useAdminSummary = () => {
  const profile = useAuth((state) => state.profile);
  return useQuery({
    queryKey: ["admin", "summary"],
    queryFn: async () => {
      const { summary } = await apiRequest<{ summary: AdminSummary }>("/api/admin/insights/summary");
      return summary;
    },
    staleTime: 60_000,
    enabled: Boolean(profile),
  });
};
